<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column is-three-fifths" style="margin: 0px 15%; font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Press</p>
              <p class="subtitle has-text-white">
                Photos of Emanuele Viscuso and friends
              <br/><br/>
              <ul>
              <li  ><a href="https://www.facebook.com/media/set/?set=a.213958522176&l=bc20a91199" target="_blank">VIP Photos</a></li>
              <li  ><a href="http://www.facebook.com/album.php?aid=231209&id=668452176&l=d1061f1080" target="_blank" >Articles about his art (Italian) </a></li>
              <li  ><a href="http://www.facebook.com/album.php?aid=231186&id=668452176&l=6d7ac439de" target="_blank">Articles about his art (English)</a></li>
              <li  ><a href="http://www.facebook.com/album.php?aid=301482&id=668452176&l=e92990539d" target="_blank">Articles about his music</a></li>
              <li  ><a href="pdf_article/TrompeArticle.pdf" download="" target="_blank">Articles about his design</a></li>
              <li  ><a href="articles_pdf/TempodiCasa.pdf"  download="" target="_blank">Magazine Tempodi Casa : about his home in Milan</a></li>
              <li  ><a href="articles_pdf/MiniAppartamenti.pdf"  download="" target="_blank">Magazine MiniAppartamenti : about his home in Milan</a></li>
              <li  ><a href="articles_pdf/Living.pdf"  download="" target="_blank">Magazine Living : about his home in Milan</a></li>
              <li  ><a href="articles_pdf/Casaviva.pdf"  download="" target="_blank">Magazine Casaviva : about his home in Milan</a></li>
              <li  ><a href="articles_pdf/TrompeFlorida.pdf"  download="" target="_blank">Magazine AQ CASE about his Florida home</a></li>
              <li  ><a href="articles_pdf/InsideSpace.pdf"  download="" target="_blank">Article about the italian food space program</a></li>
              <li  ><a href="http://www.sicilianfilmfestival.com/about-2/our-magazine/" target="_blank">Articles about the Sicilian Film Festval in Miami</a></li>
              <li  ><a href="http://www.sicilianfilmfestival.com/about-2/our-magazine/" target="_blank">Articles about the International Organ Festival</a></li>
              </ul>
              </p>
            </div>
          </section>
        </div>    
      </div>

      <section class="gallery" style="margin: 00px 15%">
          <div class="columns">
            <div class=" column is-4">
              <figure class="img-container">
                <img class="imgGallery" src="photos/Leo Matiz and Emanuele Viscuso.jpg" />
                <figcaption class="img-content">
                  <h2 class="title">Leo Matiz and Emanuele Viscuso</h2>
                  <h3 class="category">VIP photos</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Leo Matiz and Emanuele Viscuso</h2>
                  <h3 class="category">VIP Photos</h3>
                </span>
              </figure>
            </div>
            <div class=" column is-4">
              <figure class="img-container">
                <img class="imgGallery" src="images2/casavivacover.jpg" />
                <figcaption class="img-content">
                  <h2 class="title">Casa Viva</h2>
                  <h3 class="category">Article</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Casa Viva</h2>
                  <h3 class="category"> Article</h3>
                </span>
              </figure>
            </div>
            <div class=" column is-4">
              <figure class="img-container">
                <img class="imgGallery" src="images2/MINIAPPARTAMENTN25PAG3.jpg">
                <figcaption class="img-content">
                  <h2 class="title">Casa viva page 2</h2>
                  <h3 class="category"> Article</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Casa viva page 2</h2>
                  <h3 class="category"> Article</h3>
                </span>
              </figure>
            </div>
            </div>
            <div class="columns">
            <div class=" column is-6">
              <figure class="img-container">
                <img class="imgGallery" src="images2/casavivapagina2.jpg" />
                <figcaption class="img-content">
                  <h2 class="title">Casa viva page 2</h2>
                  <h3 class="category"> Article</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Casa viva page 2</h2>
                  <h3 class="category"> Article</h3>
                </span>
              </figure>
            </div>
            <div class=" column is-6">
              <figure class="img-container">
                <img class="imgGallery" src="images2/casavivapagina3.jpg" />
                <figcaption class="img-content">
                  <h2 class="title">Casa viva page 3</h2>
                  <h3 class="category"> Article</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Casa viva page 3</h2>
                  <h3 class="category"> Article</h3>
                </span>
              </figure>
            </div>
            </div>
            <div class="columns">
            <div class="column">
              <figure class="img-container">
                <img class="imgGallery" src="images2/casavivapagina4.jpg" />
                <figcaption class="img-content">
                  <h2 class="title">Casa viva page 4</h2>
                  <h3 class="category"> Article</h3>
                </figcaption>
                <span class="img-content-hover">
                  <h2 class="title">Casa viva page 4</h2>
                  <h3 class="category"> Article</h3>
                </span>
              </figure>
            
            </div>
          </div>
        <div class="columns">
        
          <div class=" column is-4">
          
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina5.jpg" />
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 5o</h2>
                <h3 class="category">Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 5</h2>
                <h3 class="category">Article</h3>
              </span>
            </figure>
          </div>
          <div class=" column is-4">
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina6.jpg" />
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 6</h2>
                <h3 class="category">Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 6</h2>
                <h3 class="category"> Article</h3>
              </span>
            </figure>
          </div>
          <div class=" column is-4">
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina7.jpg">
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 7</h2>
                <h3 class="category"> Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 7</h2>
                <h3 class="category"> Article</h3>
              </span>
            </figure>
          </div>
          </div>
          <div class="columns">
          <div class=" column is-6">
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina8.jpg" />
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 8</h2>
                <h3 class="category"> Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 8</h2>
                <h3 class="category"> Article</h3>
              </span>
            </figure>
          </div>
          <div class=" column is-6">
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina9.jpg" />
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 9</h2>
                <h3 class="category"> Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 9</h2>
                <h3 class="category"> Article</h3>
              </span>
            </figure>
          </div>
          </div>
          <div class="columns">
          <div class="column">
            <figure class="img-container">
              <img class="imgGallery" src="images2/casavivapagina10.jpg" />
              <figcaption class="img-content">
                <h2 class="title">Casa viva page 10</h2>
                <h3 class="category"> Article</h3>
              </figcaption>
              <span class="img-content-hover">
                <h2 class="title">Casa viva page 10</h2>
                <h3 class="category"> Article</h3>
              </span>
            </figure>
        
        </div>
    </div>
</section>
          
        </div>
</template>

<script>
export default {
  name: "Press",
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.gallery {
  padding: 0 0 4rem 0;
}

.img-container {
  width: 100%;
  height: 500px;
  cursor: pointer;
  overflow: hidden;
  &:hover .img-content-hover {
    display: block;
  }
}

.imgGallery {
  padding: 10px;
  width: 100%;
  height: 500px;
  object-fit: cover;
  transform: scale(1);
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
}

.img-content {
  display: none;
}
.img-content-hover {
  z-index: 10;
  position: fixed;
  top: 50px;
  left: 50px;
  white-space: nowrap;
  display: none;
  padding: 1rem;
  background: #5b5b5b;
  font-weight: 400;
  margin-top: 1.25rem;
  margin-left: -2rem;
}

.title {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
}

.category {
  font-size: 1rem;
  color: white;
}

@media screen and (max-width: 1024px) {
  img:hover {
    transform: none;
  }

  .img-container {
    height: 100%;
    &:hover .img-content-hover {
      display: none;
    }
  }

  .img-content {
    display: block;
  }
}

.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
